import { useTranslation } from 'react-i18next'
import RouterNavLink from '@/components/common/RouterNavLink'
import VersionContainer from './VersionContainer'

export default function Footer() {
  const { t } = useTranslation('common')
  const testIdInit = 'footer'

  return (
    <footer
      className="rea-footer after:content-none !mt-2.5 !p-1 dark:bg-cool-gray-800 dark:text-cool-gray-200 dark:shadow-none dark:border-t dark:border-cool-gray-200"
      role="contentinfo"
      data-testid={testIdInit}
    >
      <div
        className="container mx-auto flex items-center flex-col md:flex-row justify-between"
        data-testid={`${testIdInit}-content`}
      >
        <div className="flex mb-1 md:mb-0 lg:items-center">
          <VersionContainer />
        </div>
        <ul
          className="flex flex-wrap justify-center lg:justify-end gap-1 !mb-0"
          data-testid={`${testIdInit}-content-links`}
        >
          <li className="!px-0">
            <RouterNavLink to="/faq" data-testid={`${testIdInit}-link-faq`}>
              {t('footer.faq_link')}
            </RouterNavLink>
          </li>
          <li className="!px-0">
            <RouterNavLink
              to="/handbuch.pdf"
              target="_blank"
              data-testid={`${testIdInit}-link-handbuch`}
            >
              {t('footer.manual')}
            </RouterNavLink>
          </li>
          <li className="!px-0">
            <RouterNavLink
              to="/datenschutz"
              data-testid={`${testIdInit}-link-datenschutz`}
            >
              {t('footer.privacy_policy_link')}
            </RouterNavLink>
          </li>
          <li className="!px-0">
            <RouterNavLink
              to="/impressum"
              data-testid={`${testIdInit}-link-impressum`}
            >
              {t('footer.impressum')}
            </RouterNavLink>
          </li>
        </ul>
      </div>
    </footer>
  )
}
